import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'
import { Config } from '@chegg-wt/core/config'
import { AppState } from '@chegg-wt/core/state/types'
import { ActionTypes } from '@chegg-wt/core/state/user/constants'
import { currentRouteSelector } from '@chegg-wt/core/state/app/selectors'
import { routeToRioPageNameMap } from '../utils/pageNames'
import {
  getCheggUserUuid,
  getAuthState,
  getSubscriptionStatus,
  productMap,
} from '../utils/auth'
import { resetSyntheticLocationChange } from '../actions'
import { getUpdatedView } from './utils'
import { getRioClient } from './rioAnalytics'

export const updateRioStateLogic = createLogic<AppState>({
  type: ActionTypes.SET_USER,
  process({ getState }, dispatch, done) {
    const state = getState()
    const authState = getAuthState(state)
    const cheggUuid = getCheggUserUuid(state) || undefined
    const { tokenSiteCode: site } = Config
    getRioClient().updateState({
      authState,
      subscriptions: [
        {
          status: getSubscriptionStatus(state),
          product: productMap[site],
        },
      ],
      cheggUuid,
    })
    done()
  },
})

export const updateRioStateViewLogic = createLogic<AppState>({
  type: getType(resetSyntheticLocationChange),
  process({ getState }, _, done) {
    const currentRoute = currentRouteSelector(getState())
    const page = routeToRioPageNameMap[currentRoute]

    if (!page) {
      done()
    }

    const view = getUpdatedView({
      site: Config.tokenSiteCode,
      page,
    })

    getRioClient().updateState({
      view,
    })

    done()
  },
})
